import { ProductSpecModel } from '../model'
import {
  type ArtworkFile,
  type LocationMethod,
  OrderType
} from '../types'
import {
  type VirtualDesignArt,
  type VirtualDesignFont,
  type VirtualDesignImage,
  type VirtualDesignLogo
} from '../types/online-designer'
import { useWindow } from './use-window'

export type VirtualDesignCallback = {
  logo: VirtualDesignLogo[];
  design: VirtualDesignImage;
  arts: VirtualDesignArt[];
  fonts: VirtualDesignFont[];
  json: string;
};

export const useExternal = () => {
  const { productId } = useWindow()

  const GetIframeURL= (
    artworkSourceID: string,
    SysNo: number,
    OrderType: OrderType,
    IntNull: number,
    Customize: string,
    method: LocationMethod,
    selectID: string
  )=>{
    const url =
      '/SwfUpload/AddYourLogo.aspx?productid=' +
      productId +
      '&pageType=2&hideid=Hidden_' +
      artworkSourceID +
      '_' +
      SysNo +
      '&imgDivid=Div_' +
      artworkSourceID +
      '_' +
      SysNo +
      '&OrderType=' +
      OrderType +
      '&OrderSysNo=' +
      IntNull +
      '&ImprintSysNo=' +
      SysNo +
      '&ArtworkSource=' +
      Customize +
      '&SelectIDs=' +
      selectID

    return url;
  }
  const openBoxFile = (): Promise<ArtworkFile[]> => {
    
    return new Promise((resolve, reject) => {
    
      (window as any).SetOrderArtworkByImprintSysNo = function (
        showId: string,
        hiddenId: string,
        artworkSource: string,
        imprintSysNo: string,
        newArtwork: string,
        viewUrl: string
      ) {
        // ec.log(arguments);
        const arr = newArtwork.split('_|_')

        const artworkFiles: ArtworkFile[] = []
        for (let i = 0; i < arr.length; i++) {
          if (arr[i] === '') break

          const s = arr[i].split('_||_')
          const data = {
            BoxNetFileSysNo: parseInt(s[1]),
            DownloadUrl: '',
            FileID: '',
            FileName: s[0],
            FileExt: s[2],
            ThumbnailUrl: s[3],
            PreviewUrl: '/SwfUpload/' + viewUrl
          } as ArtworkFile

          artworkFiles.push(data)
        }
        resolve(artworkFiles)
      }
    })
  }

  const openOnlineDesigner = (
    method: LocationMethod,
    productSpecList: ProductSpecModel[],
    virtualDesignImage?: VirtualDesignImage,
    virtualDesignJson?: string
  ): Promise<VirtualDesignCallback> => {
    const params: Record<string, any> = {
      imprintSysNo: method.SysNo,
      productid: productId,
      logoBoxSysNo: undefined
    }
    if (virtualDesignImage) {
      params.logoBoxSysNo = virtualDesignImage.SysNo
    }

    return new Promise((resolve, reject) => {
      const count = productSpecList.length
      if (count > 0) {
        let filename = productSpecList[count - 1].previewImage
        // 先获取JSON，然后写入到localstorage里
        if (virtualDesignImage != null) {
          localStorage.setItem(
            'virtualDesign' + method.SysNo,
            virtualDesignJson ?? ''
          )
          params.opt = 'edit'
        }
        const queryString = Object.keys(params)
          .map((key) => key + '=' + params[key])
          .join('&')
        // 先判断有没有版本号
        if (/\/v[\d]+/.test(filename)) {
          // 删除版本号
          filename = filename.replace(/\/v[\d]+/, '')
        }
        filename = filename.substring(filename.lastIndexOf('/') + 1);

        (window as any).openWindowS(
          '/OnlineDesigner.aspx?' + queryString + '&specImg=' + filename + '',
          '1230',
          '830'
        );
        (window as any).setVirtualEffect = function (
          logo: VirtualDesignLogo[],
          design: VirtualDesignImage,
          arts: VirtualDesignArt[],
          fonts: VirtualDesignFont[],
          json: string
        ) {
          resolve({
            logo,
            design,
            arts,
            fonts,
            json
          })
          // method.virtualDesignLogo = logo;
          // method.virtualDesignImage = design;
          // //virtualDesignImage
          // method.virtualDesignJson = json;
          // method.virtualDesignArts.splice(0);
          // method.virtualDesignFonts.splice(0);
          // arts.forEach(function (font) {
          //   method.virtualDesignArts.push(font);
          // });
          // fonts.forEach(function (font) {
          //   method.virtualDesignFonts.push(font);
          // });

          // //如果
          // if (
          //   method.artworkFiles.length > 0 ||
          //   method.virtualDesignImage != null
          // ) {
          //   method.ShowNoLogoMsg = false;
          //   method.NoArtInstruction = false;
          // }
        }
      }
    })
  }
  return { GetIframeURL,openBoxFile, openOnlineDesigner }
}
